import { useEffect, useRef } from 'react';
import { formatActivityWhen } from './ist-datetime';

export function useHindiNotify(activityLog) {
  const seenRef = useRef(new Set());

  useEffect(() => {
    if (!activityLog?.length) return;
    const latest = activityLog[0];
    const key = `${latest.time}-${latest.hindi || latest.message}`;
    if (seenRef.current.has(key)) return;
    seenRef.current.add(key);

    const isBotTrade = latest.botTrade === true
      || ['trade_open', 'trade_close', 'target_hit'].includes(latest.type);
    if (!isBotTrade || !('Notification' in window)) return;
    const body = latest.hindi || latest.message;

    if (Notification.permission === 'granted') {
      new Notification('BharatDesk', { body, tag: 'bharatdesk-trade' });
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then((perm) => {
        if (perm === 'granted') new Notification('BharatDesk', { body, tag: 'bharatdesk-trade' });
      });
    }
  }, [activityLog]);
}

const LEGEND = [
  { icon: '🟢', text: 'हरा दिन — बॉट लक्ष्य की ओर ट्रेड करता है' },
  { icon: '⚠️', text: 'गलत ट्रेड — जल्दी नुकसान काटता है' },
  { icon: '🛑', text: 'हानि हुई — आज के लिए रुक जाता है' },
  { icon: '🔴', text: 'दिन लाल — सब बंद, तुरंत रुकता है' },
  { icon: '💪', text: '₹1000 लक्ष्य — हानि पर भी नहीं रुकेगा, सिर्फ लक्ष्य पर' },
];

const typeClass = {
  green_day: 'notify-green',
  early_stop: 'notify-warn',
  loss_trade_stop: 'notify-stop',
  zero_loss_day: 'notify-red',
  max_daily_loss: 'notify-red',
  breakeven_armed: 'notify-lock',
  breakeven_lock: 'notify-lock',
  target_hit: 'notify-gold',
  trade_open: 'notify-trade',
  sell_now: 'notify-green',
  stop_now: 'notify-stop',
  timeout_profit_sell: 'notify-green',
  near_target: 'notify-warn',
  blocked: 'notify-warn',
  relentless: 'notify-relentless'
};

export default function HindiNotifyPanel({ activityLog = [], lastAction, lastHindiAlert }) {
  const latest = lastHindiAlert || activityLog.find((e) => e.alert) || activityLog[0];

  return (
    <div className="card hindi-notify-card">
      <h3>🔔 हिंदी सूचनाएँ — अभी क्या हो रहा है</h3>

      {latest && (
        <div className={`hindi-latest-alert ${typeClass[latest.type] || ''}`}>
          <span className="hindi-alert-time">{formatActivityWhen(latest)}</span>
          <div className="hindi-alert-text">{latest.hindi || latest.message}</div>
        </div>
      )}

      <div className="hindi-current-status">
        <span className="label">अभी की स्थिति:</span> {lastAction || 'प्रतीक्षा...'}
      </div>

      <div className="hindi-legend">
        <div className="hindi-legend-title">बॉट ऐसे काम करता है:</div>
        {LEGEND.map((item) => (
          <div key={item.icon} className="hindi-legend-row">
            <span>{item.icon}</span> {item.text}
          </div>
        ))}
      </div>

      <div className="hindi-feed">
        {(activityLog || []).slice(0, 10).map((e, i) => (
          <div key={i} className={`hindi-feed-item ${typeClass[e.type] || ''} ${e.alert ? 'is-alert' : ''}`}>
            <span className="hindi-feed-time">{formatActivityWhen(e)}</span>
            <span>{e.hindi || e.message}</span>
          </div>
        ))}
        {(!activityLog || activityLog.length === 0) && (
          <div className="hindi-feed-empty">अभी कोई सूचना नहीं — बाजार खुलने पर यहाँ दिखेगी</div>
        )}
      </div>
    </div>
  );
}

export { LEGEND };
